module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAYCAYAAAAPtVbGAAAABGdBTUEAALGPC/xhBQAAAI1JREFUSA1jYCAB/P//fysQg8BWErQxMJKiGGQ6TD0jEMDYhGgmQgqoIT9qCUmhOBpcgy+4WID5ix/orGQg5iPFeUB9DUSo/wRUM5cBqLgIiGkJiuiSuljA3oH4m5jgqkcKokYkNi4mOLiILuRApoDCFGbaaAEJCwmq03RJXaOWkBRvgzK4tkG9QFKTCAAb+oM/J0rSYQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/pages/Home/Combined Shape.png
// module id = btkU
// module chunks = 1